import React from "react"
import NewsroomLanding from "@components/pages/newsroom/newsroom-landing"
import { fetchAPI, getPageBySlug, getPostsByType } from "lib/api"
import { Q_NEWSROOM, Q_POST_YEAR_LIST } from "lib/query"

function NewsroomPage({ data, yearList, locale }) {
  return (
    <>
      <NewsroomLanding
        data={data}
        locale={locale}
        yearList={yearList?.postYearList}
      />
    </>
  )
}
export default NewsroomPage

export async function getStaticProps(ctx) {
  const { locale } = ctx
  const yearList = await fetchAPI(Q_POST_YEAR_LIST, {
    variables: { post_type: "NEWS" },
  })
  const data = await fetchAPI(Q_NEWSROOM, {
    variables: {
      slug: "media-kit",
      year: yearList?.postYearList?.length && yearList?.postYearList[0],
    },
  })
  return {
    props: {
      seo: {
        title: "Newsroom",
      },
      page: "newsroom-landing",
      theme: "white",
      data,
      locale,
      yearList,
    },
    revalidate: 60,
  }
}
